// extracted by mini-css-extract-plugin
var _1 = "CompanySubmenuStyle-module__active___Mi2tE";
var _2 = "CompanySubmenuStyle-module__button___nm_GK";
var _3 = "CompanySubmenuStyle-module__button-public___Wtb9m";
var _4 = "CompanySubmenuStyle-module__button-public___Wtb9m";
var _5 = "CompanySubmenuStyle-module__buttons-holder___nSe7j";
var _6 = "CompanySubmenuStyle-module__buttons-holder___nSe7j";
var _7 = "CompanySubmenuStyle-module__company-avatar___cxNNk";
var _8 = "CompanySubmenuStyle-module__company-details___R1MO5";
var _9 = "CompanySubmenuStyle-module__company-menu___jTbpR";
var _a = "CompanySubmenuStyle-module__company-menu-open___T6s9Q";
var _b = "CompanySubmenuStyle-module__company-name___eY2d9";
var _c = "CompanySubmenuStyle-module__company-submenu___oXIOm";
var _d = "CompanySubmenuStyle-module__company-submenu-holder___CK9oF";
var _e = "CompanySubmenuStyle-module__company-avatar___cxNNk";
var _f = "CompanySubmenuStyle-module__company-details___R1MO5";
var _10 = "CompanySubmenuStyle-module__company-menu___jTbpR";
var _11 = "CompanySubmenuStyle-module__company-menu-open___T6s9Q";
var _12 = "CompanySubmenuStyle-module__company-name___eY2d9";
var _13 = "CompanySubmenuStyle-module__company-submenu___oXIOm";
var _14 = "CompanySubmenuStyle-module__company-submenu-holder___CK9oF";
var _15 = "CompanySubmenuStyle-module__icon___yhDPi";
var _16 = "CompanySubmenuStyle-module__link___JWuiZ";
var _17 = "CompanySubmenuStyle-module__links-toogle___OHALN";
var _18 = "CompanySubmenuStyle-module__links-toogle-open___sFrIQ";
var _19 = "CompanySubmenuStyle-module__links-toogle___OHALN";
var _1a = "CompanySubmenuStyle-module__links-toogle-open___sFrIQ";
var _1b = "CompanySubmenuStyle-module__menu-item___Ti76Q";
var _1c = "CompanySubmenuStyle-module__menu-item___Ti76Q";
var _1d = "CompanySubmenuStyle-module__new-submenu___E8_XJ";
var _1e = "CompanySubmenuStyle-module__new-submenu___E8_XJ";
var _1f = "CompanySubmenuStyle-module__svg-icon___eDeNc";
var _20 = "CompanySubmenuStyle-module__svg-icon___eDeNc";
export { _1 as "active", _2 as "button", _3 as "button-public", _4 as "buttonPublic", _5 as "buttons-holder", _6 as "buttonsHolder", _7 as "company-avatar", _8 as "company-details", _9 as "company-menu", _a as "company-menu-open", _b as "company-name", _c as "company-submenu", _d as "company-submenu-holder", _e as "companyAvatar", _f as "companyDetails", _10 as "companyMenu", _11 as "companyMenuOpen", _12 as "companyName", _13 as "companySubmenu", _14 as "companySubmenuHolder", _15 as "icon", _16 as "link", _17 as "links-toogle", _18 as "links-toogle-open", _19 as "linksToogle", _1a as "linksToogleOpen", _1b as "menu-item", _1c as "menuItem", _1d as "new-submenu", _1e as "newSubmenu", _1f as "svg-icon", _20 as "svgIcon" }
